import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReviewVerifyService } from './review.service';

@Component({
  selector: 'app-verify-review',
  templateUrl: './verify-review.component.html',
  styleUrls: ['./verify-review.component.css'],
  standalone: false
})
export class VerifyReviewComponent {

  token?: string;
  wentWrong = false;
  success = false;
  alreadyVerified = false;
  errorMessage = 'Verification failed';

  constructor(
    activatedRoute: ActivatedRoute,
    private router: Router,
    private reviewVerifyService: ReviewVerifyService
  ) {
    activatedRoute.queryParams.subscribe(async params => {
      this.token = params['token'];

      if (!this.token) {
        this.router.navigate(['/']);
      } else {
        try {
          await this.reviewVerifyService.verifyReview(this.token);
          this.success = true;
        } catch (error: any) {
          console.error(error);
          this.errorMessage = error?.error?.message || 'Verification failed';
          if (error?.status?.toString() === '409') {
            this.alreadyVerified = true;
          }
          this.wentWrong = true;
        }
      }
    });
  }

  toDashboard() {
    this.router.navigate(['/']);
  }
}

